import { QuizSessionPhase } from '../api/quiz-session-phase'

export interface QuizSessionTrackingState {
  id: string
  quizId: string
  aspect: string
  type: '' | string // e.g. practice or exam
  phase: QuizSessionPhase
  content: unknown
}

export function defaultQuizSessionTrackingState(id: string): QuizSessionTrackingState {
  return {
    id,
    quizId: '',
    aspect: '',
    type: '',
    phase: '',
    content: undefined
  }
}
